"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyShader = void 0;
const gl_shader_1 = require("../gl-shader");
/**
 * @public
 */
exports.emptyShader = new gl_shader_1.GlShader("");
//# sourceMappingURL=empty-shader.js.map